import React, { createContext, useContext, useState, useEffect } from 'react';
import { getDefaultLanguage } from '../utils/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children, selectedCountry = null }) => {
  // Bestimme die Standardsprache basierend auf dem Land
  const defaultLanguage = selectedCountry ? getDefaultLanguage(selectedCountry) : 'en';
  
  // Lade die gespeicherte Sprache aus localStorage oder verwende die Standardsprache
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('v3tax-language');
    const initial = savedLanguage || defaultLanguage;
    // Sofort persistieren, damit getUiLanguage() (Geo-Toasts etc.) dieselbe Sprache sieht wie React-State
    // bevor der erste useEffect läuft.
    try {
      if (!savedLanguage) {
        localStorage.setItem('v3tax-language', initial);
      }
    } catch (_) {
      /* ignore */
    }
    return initial;
  });

  // Speichere die Sprache in localStorage wenn sie sich ändert
  useEffect(() => {
    localStorage.setItem('v3tax-language', language);
  }, [language]);

  // Aktualisiere die Sprache wenn sich das Land ändert (nur wenn keine manuelle Auswahl getroffen wurde)
  useEffect(() => {
    if (selectedCountry) {
      const countryLanguage = getDefaultLanguage(selectedCountry);
      const savedLanguage = localStorage.getItem('v3tax-language');
      
      // Nur ändern wenn keine manuelle Sprachauswahl getroffen wurde
      if (!savedLanguage) {
        setLanguage(countryLanguage);
      }
    }
  }, [selectedCountry]);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  const value = {
    language,
    changeLanguage,
    selectedCountry
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 